/**
 * @generated SignedSource<<3899b8733ba6e7fa9ae649f9b64eb5ae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion">;
  readonly " $fragmentType": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion";
};
export type ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion$key = {
  readonly " $data"?: ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeaderWithErrorBoundary_jiraVersion",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionDetailIssueList_IssueListWithHeader_jiraVersion"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "dcffc936c288beebfd459b5bcb75d18a";

export default node;
